import DataService from "@/services/data.service"
import { utils } from "@/store/helpers"
import store from "@/store"
import router from "@/router"
import { ALL_EMITTERS } from "@/store/constants/all_emitters"
import { v4 as uuidv4 } from "uuid"

// import dummy from "./dummy"

const initialState = {
  records_fetched: {},
  records_notes_fetched: {},
  records_currently_fetching: [],

  graphs_fetched: {},
  graphs_notes_fetched: {},
  graphs_currently_fetching: [],
  get_graphs_promises_queue: [],

  record_notes_currently_fetching: null,
  teams: [],
  users: [],
  organization_users: [],
  notifications: [],
  tags: [],
  actions_tags: [],
  note_categories: [],
  metrics: [],
  records: [],
  groups: [],
  graphs: [],
  all_graphs: [],
  recent_searches: [],
  solid_metrics_phases: {},
  solid_metrics_growth: {},
  solid_metrics_suggested: {},
  emails_summary: null,
  workspace_organizations: [],
  get_record_promises_queue: [],
  get_record_notes_promises_queue: [],
  selected_organization: null,
  // Keeps track of the current object type
  // that is displayed for the user

  current_object_type: {},
  object_types: [],
  portfolio: { companies_page_rollup_metrics: [], companies_page_table_metrics: [], ui_options: {} },
  integrations: null,
  current_forecast: null,
  user_forecasts: [],
  forecast_current_object: null,
  forecasted_objects: [],
  metrics_tags: [
    { label: "Health Score", value: "health_score" },
    { label: "Usage", value: "usage" },
    { label: "Adoption", value: "adoption" },
    { label: "Product(s)", value: "product" },
    { label: "CS Score", value: "cs_score" },
    { label: "Potential Expansion", value: "potential_expansion" },
    { label: "Annual Recurring Revenue (ARR)", value: "annual_recurring_revenue" },
    { label: "Monthly Recurring Revenue (MRR)", value: "monthly_recurring_revenue" },
    { label: "Total Contract Value (TCV)", value: "total_contract_value" },
    { label: "Current Contract Start Date", value: "current_contract_start_date" },
    { label: "Current Contract End Date", value: "current_contract_end_date" },
    { label: "Position/Role", value: "position_role" },
    { label: "Decision Maker", value: "decision_maker" },
    { label: "Influencer", value: "influencer" }
  ],
  interaction_types: [
    {
      label: "Call",
      value: "call",
      categories: [
        { label: "Renewal", value: "renewal" },
        { label: "Support", value: "support" },
        { label: "Expansion", value: "expansion" },
        { label: "Onboarding", value: "onboarding" },
        { label: "Business Review", value: "business_review" },
        { label: "Consultation", value: "consultation" },
        { label: "Training", value: "training" },
        { label: "QBR", value: "qbr" },
        { label: "EBR", value: "ebr" },
        { label: "Sales", value: "sales" },
        { label: "Cross-sale", value: "cross-sale" },
        { label: "Demo", value: "demo" },
        { label: "Discovery", value: "discovery" },
        { label: "Cold call", value: "cold_call" },
        { label: "Other", value: "other" }
      ]
    },
    {
      label: "Meeting",
      value: "meeting",
      categories: [
        { label: "Renewal", value: "renewal" },
        { label: "Support", value: "support" },
        { label: "Expansion", value: "expansion" },
        { label: "Onboarding", value: "onboarding" },
        { label: "Business Review", value: "business_review" },
        { label: "Consultation", value: "consultation" },
        { label: "Training", value: "training" },
        { label: "QBR", value: "qbr" },
        { label: "EBR", value: "ebr" },
        { label: "Sales", value: "sales" },
        { label: "Cross-sale", value: "cross-sale" },
        { label: "Demo", value: "demo" },
        { label: "Discovery", value: "discovery" },
        { label: "Other", value: "other" }
      ]
    },
    {
      label: "Email",
      value: "email",
      categories: [
        { label: "Renewal", value: "renewal" },
        { label: "Support", value: "support" },
        { label: "Expansion", value: "expansion" },
        { label: "Onboarding", value: "onboarding" },
        { label: "Business Review", value: "business_review" },
        { label: "Consultation", value: "consultation" },
        { label: "Training", value: "training" },
        { label: "Sales", value: "sales" },
        { label: "Cross-sale", value: "cross-sale" },
        { label: "Pitch", value: "pitch" },
        { label: "Follow up", value: "follow_up" },
        { label: "Other", value: "other" }
      ]
    },
    {
      label: "WhatsApp",
      value: "whatsapp",
      categories: [
        { label: "Renewal", value: "renewal" },
        { label: "Support", value: "support" },
        { label: "Expansion", value: "expansion" },
        { label: "Onboarding", value: "onboarding" },
        { label: "Business Review", value: "business_review" },
        { label: "Consultation", value: "consultation" },
        { label: "Training", value: "training" },
        { label: "Sales", value: "sales" },
        { label: "Cross-sale", value: "cross-sale" },
        { label: "Pitch", value: "pitch" },
        { label: "Follow up", value: "follow_up" },
        { label: "Other", value: "other" }
      ]
    },
    { label: "Note", value: "note", categories: [] },
    {
      label: "Support",
      value: "support",
      categories: [
        { label: "Ticket", value: "ticket" },
        { label: "Chat", value: "chat" },
        { label: "In-app", value: "in-app" }
      ]
    },
    {
      label: "Marketing",
      value: "marketing",
      categories: [
        { label: "Webinar", value: "webinar" },
        { label: "Campaign", value: "campaign" },
        { label: "Inbound", value: "inbound" },
        { label: "Resources", value: "resources" },
        { label: "Website", value: "website" },
        { label: "Other", value: "other" }
      ]
    },
    { label: "Other", value: "other", categories: [] }
  ],
  interaction_categories: [
    { label: "Renewal", value: "renewal" },
    { label: "Support", value: "support" },
    { label: "Expansion", value: "expansion" },
    { label: "Onboarding", value: "onboarding" },
    { label: "Business Review", value: "business_review" },
    { label: "Consultation", value: "consultation" },
    { label: "Training", value: "training" },
    { label: "QBR", value: "qbr" },
    { label: "EBR", value: "ebr" },
    { label: "Ticket", value: "ticket" },
    { label: "Chat", value: "chat" },
    { label: "In-app", value: "in-app" },
    { label: "Webinar", value: "webinar" },
    { label: "Campaign", value: "campaign" },
    { label: "Inbound", value: "inbound" },
    { label: "Resources", value: "resources" },
    { label: "Website", value: "website" },
    { label: "Sales", value: "sales" },
    { label: "Cross-sale", value: "cross-sale" },
    { label: "Demo", value: "demo" },
    { label: "Discovery", value: "discovery" },
    { label: "Cold call", value: "cold_call" },
    { label: "Pitch", value: "pitch" },
    { label: "Follow up", value: "follow_up" },
    { label: "Other", value: "other" }
  ],

  task_priorities: [
    { name: "Lowest", value: "lowest" },
    { name: "Low", value: "low" },
    { name: "Normal", value: "normal" },
    { name: "High", value: "high" },
    { name: "Highest", value: "highest" }
  ],
  task_statuses: [
    { name: "Pending", value: "pending" },
    { name: "In-Progress", value: "in-progress" },
    { name: "Completed", value: "completed" },
    { name: "Canceled", value: "cancelled" },
    { name: "Overdue", value: "overdue" }
  ],
  goal_types: [
    {
      label: "Specific",
      value: "specific",
      description: "Set a specific goal such as “Book an upsell meeting with the decision maker and team at this record.”"
    },
    { label: "Measurable", value: "measurable", description: "Set a measurable such as “Increase ARR with 100k.“" },
    { label: "Time-Bound", value: "time-Bound", description: "Set a time-bound goal such as “Q4 100k expansion goal.“" }
  ],
  goal_statuses: [
    { name: "Pending", value: "pending" },
    { name: "In-Progress", value: "in-progress" },
    { name: "Completed", value: "completed" },
    { name: "Missed", value: "missed" },
    { name: "Overdue", value: "overdue" }
  ],
  plan_types: [
    { label: "Account Plan", value: "account_plan" },
    { label: "Growth Plan", value: "growth_plan" },
    { label: "Success Plan", value: "success_plan" },
    { label: "Onboarding Plan", value: "onboarding_plan" },
    { label: "Health Plan", value: "health_plan" },
    { label: "Renewal Plan", value: "renewal_plan" },
    { label: "Other", value: "other" }
  ],
  plan_statuses: [
    { name: "Pending", value: "pending" },
    { name: "In-Progress", value: "in-progress" },
    { name: "Completed", value: "completed" },
    { name: "Missed", value: "missed" },
    { name: "Overdue", value: "overdue" }
  ],
  filter_logic_operators: [
    { label: "And", value: "and" },
    { label: "Or", value: "or" }
  ],
  filter_logic_clauses: [
    { hint: "Match all of", label: "All", value: "(and", inner_operator: "and" },
    { hint: "Match at least one of", label: "One of", value: "(or", inner_operator: "or" },
    { hint: "Do not match at least one of", label: "None of", value: "!(or", inner_operator: "or" }
  ],
  filter_operators: [
    { for: "number", label: "Greater than", value: ">" },
    { for: "date_datetime", label: "Date is after", value: ">" },
    { for: "time", label: "Time is after", value: ">" },
    { for: "time", label: "Time is before", value: "<" },
    { for: "number", label: "Less than", value: "<" },
    { for: "date_datetime", label: "Date is before", value: "<" },
    { for: "number_playbook", label: "Is equal to", value: "==" },
    { for: "string", label: "Text is exactly", value: "==" },
    { for: "list", label: "Text is exactly", value: "==" },
    { for: "date_datetime", label: "Date is", value: "==" },
    { for: "number", label: "Is not equal to", value: "!=" },
    { for: "string", label: "Text is not", value: "!=" },
    { for: "list", label: "Text is not", value: "!=" },
    { for: "date_datetime", label: "Exclude exact date", value: "!=" },
    { for: "boolean", label: "Is Checked", value: "==" },
    { for: "boolean", label: "Is Not Checked", value: "!=" },
    { for: "number", label: "Greater than or equal to", value: ">=" },
    { for: "number", label: "Less than or equal to", value: "<=" },
    { for: "string", label: "Text contains", value: "__INCLUDES__" },
    { for: "json_list", label: "Text contains", value: "__INCLUDES__" },
    { for: "string", label: "Text does not contain", value: "__EXCLUDES__" },
    { for: "json_list", label: "Text does not contain", value: "__EXCLUDES__" },
    { for: "number_string_date_datetime_time_list", label: "Is empty", value: "__ISNULL__" },
    { for: "number_string_date_datetime_time_list", label: "Is not empty", value: "__IS_NOT_NULL__" },
    { for: "date_datetime", label: "Within the last X days", value: "__DAYS_WITHIN_LAST_X_DAYS__" },
    { for: "date_datetime", label: "More than X days ago", value: "__DAYS_MORE_THAN_X_DAYS_AGO__" },
    { for: "date_datetime", label: "X exact days ago", value: "__DAYS_EXACT_DAYS_AGO__" },
    { for: "date_datetime", label: "More than X days from now", value: "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" },
    { for: "date_datetime", label: "Within the next X days", value: "__DAYS_WITHIN_NEXT_X_DAYS__" },
    { for: "date_datetime", label: "X exact days from now", value: "__DAYS_EXACT_DAYS_FROM_NOW__" },
    { for: "date_datetime", label: "Within range", value: "__DAYS_WITHIN_RANGE__" }
  ],
  playbook_filter_operators: [
    { for: "number", label: "Increase by more than X", value: ">>" },
    { for: "number", label: "Decrease by more than X", value: "<<" }
  ],
  metric_action_options: [
    { for: "number_string_date_time_list_plan_goal_task_interaction_milestone", label: "update to", value: "=" }
    // { for: "number", label: "increase value by", value: "+=" },
    // { for: "date", label: "add X days to date", value: "+=" },
    // { for: "number", label: "decrease value by", value: "-=" },
    // { for: "date", label: "go back X days", value: "-=" }
  ],
  notifications_filter_operators: [
    { for: "number", label: "Increased", value: "increased" },
    { for: "number", label: "Decreased", value: "descreased" },
    { for: "number_string_date_boolean_list", label: "Deleted", value: "deleted" },
    { for: "string_date_boolean_list", label: "Updated", value: "updated" },
    { for: "number", label: "Greater than", value: ">" },
    { for: "date", label: "After", value: ">" },
    { for: "time", label: "After", value: ">" },
    { for: "time", label: "Before", value: "<" },
    { for: "number", label: "Less than", value: "<" },
    { for: "date", label: "Before", value: "<" },
    { for: "number_string_list", label: "Equal to", value: "==" },
    { for: "date", label: "Exact Date", value: "==" },
    { for: "number_string_list", label: "Not Equal to", value: "!=" },
    { for: "date", label: "Exclude", value: "!=" },
    { for: "boolean", label: "Is Checked", value: "==" },
    { for: "boolean", label: "Is Not Checked", value: "!=" },
    { for: "number", label: "Greater or equal to", value: ">=" },
    { for: "number", label: "Less than or equal to", value: "<=" },
    { for: "string_json_list", label: "Includes", value: "__INCLUDES__" },
    { for: "string_json_list", label: "Excludes", value: "__EXCLUDES__" },
    { for: "number_string_date_time_list", label: "Is empty", value: "__ISNULL__" },
    { for: "date", label: "More than days ago", value: "__DAYS_WITHIN_LAST_X_DAYS__" },
    { for: "date", label: "Less than days ago", value: "__DAYS_MORE_THAN_X_DAYS_AGO__" },
    { for: "date", label: "Exact days ago", value: "__DAYS_EXACT_DAYS_AGO__" },
    { for: "date", label: "More than days from now", value: "__DAYS_MORE_THAN_X_DAYS_FROM_NOW__" },
    { for: "date", label: "Less than days from now", value: "__DAYS_WITHIN_NEXT_X_DAYS__" },
    { for: "date", label: "Exact days from now", value: "__DAYS_EXACT_DAYS_FROM_NOW__" }
  ],

  graphs_default_colors: [
    "#6ED7F8",
    "#F0949E",
    "#54a0ff",
    "#93D076",
    "#FAF4AF",
    "#2ecc71",
    "#3498db",
    "#9b59b6",
    "#34495e",
    "#16a085",
    "#27ae60",
    "#2980b9",
    "#8e44ad",
    "#2c3e50",
    "#f1c40f",
    "#e67e22",
    "#e74c3c",
    "#5af1f1",
    "#95a5a6",
    "#f39c12",
    "#d35400",
    "#c0392b",
    "#bdc3c7",
    "#7f8c8d",
    "#55efc4",
    "#81ecec",
    "#74b9ff",
    "#a29bfe",
    "#dfe119",
    "#00b894",
    "#00cec9",
    "#0984e3",
    "#6c5ce7",
    "#ffeaa7",
    "#fab1a0",
    "#ff7675",
    "#fd79a8",
    "#fdcb6e",
    "#e17055",
    "#d63031",
    "#feca57",
    "#5f27cd",
    "#54a0ff",
    "#01a3a4"
  ],
  record_interactions: {},
  interactions: { count: 0, next: null, previous: null, results: [] },
  calendar_interactions: { count: 0, next: null, previous: null, results: [] },
  record_tasks: {},
  tasks: { count: 0, next: null, previous: null, results: [] },
  record_goals: {},
  record_plans: {},
  goals: { count: 0, next: null, previous: null, results: [] },
  calendar_goals: { count: 0, next: null, previous: null, results: [] },
  plans: { count: 0, next: null, previous: null, results: [] },
  calendar_plans: { count: 0, next: null, previous: null, results: [] },
  prospecting_filter: null,
  phases_object_type: null,
  suggested_object_type: null,
  growth_object_type: null,
  plan_data: {},
  workspaces: [],
  playbook_triggers: [],
  pending_playbook: null
}

export const data = {
  namespaced: true,
  state: initialState,
  actions: {
    "WORKSPACE.DELETE": {
      // Don't change!. Predefined actions called by the server
      root: true,
      async handler({ commit }, data) {
        commit("data/deleteWorkspace", data.workspace_short_id, { root: true })
        if (
          (router.currentRoute.value.name == "WorkspaceForm" || router.currentRoute.value.name == "WorkspaceItem") &&
          store.state.ui.currentWorkspace.short_id == data.workspace_short_id
        ) {
          router.replace("/workspace")
        }
      }
    },

    "WORKSPACE.ADD-TO-USER": {
      // Don't change!. Predefined actions called by the server
      root: true,
      async handler({ commit }, data) {
        if (data.user == store.state.auth.user.id) {
          commit("data/addWorkspace", data.workspace, { root: true })
        }
      }
    },

    "WORKSPACE.REMOVE-FROM-USER": {
      // Don't change!. Predefined actions called by the server
      root: true,
      async handler({ commit }, data) {
        if (data.user == store.state.auth.user.id) {
          commit("data/deleteWorkspace", data.workspace_short_id, { root: true })
          if (
            (router.currentRoute.value.name == "WorkspaceForm" || router.currentRoute.value.name == "WorkspaceItem") &&
            store.state.ui.currentWorkspace.short_id == data.workspace_short_id
          ) {
            router.replace("/workspace")
          }
        }
      }
    },

    "WORKSPACE.UPDATE": {
      // Don't change!. Predefined actions called by the server
      root: true,
      async handler({ commit, dispatch }, data) {
        commit("data/updateWorkspace", data.workspace, { root: true })

        if (store.state.ui.currentWorkspace?.short_id == data.workspace?.short_id) {
          dispatch("ui/setCurrentWorkspace", { ...store.state.ui.currentWorkspace, ...data.workspace }, { root: true })
        }
      }
    },

    PLAN: {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.NEW_PLAN_ADDED, data)
      }
    },

    "PLAN.UPDATE": {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        if (data.is_removed) {
          this.$emitter.emit(ALL_EMITTERS.PLAN_REMOVED, data)
        } else {
          this.$emitter.emit(ALL_EMITTERS.PLAN_UPDATED, data)
        }
      }
    },

    GOAL: {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.NEW_GOAL_ADDED, data)
      }
    },

    "GOAL.UPDATE": {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        if (data.is_removed) {
          this.$emitter.emit(ALL_EMITTERS.GOAL_REMOVED, data)
        } else {
          this.$emitter.emit(ALL_EMITTERS.GOAL_UPDATED, data)
        }
      }
    },

    TASK: {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.NEW_TASK_ADDED, data)
      }
    },

    "TASK.UPDATE": {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        if (data.is_removed) {
          this.$emitter.emit(ALL_EMITTERS.TASK_REMOVED, data)
        } else {
          this.$emitter.emit(ALL_EMITTERS.TASK_UPDATED, data)
        }
      }
    },

    INTERACTION: {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.NEW_INTERACTION_ADDED, data)
      }
    },

    "INTERACTION.UPDATE": {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        if (data.is_removed) {
          this.$emitter.emit(ALL_EMITTERS.INTERACTION_REMOVED, data)
        } else {
          this.$emitter.emit(ALL_EMITTERS.INTERACTION_UPDATED, data)
        }
      }
    },
    updateBulkDeleteActionStatus: {
      // Don't change!. Predefined actions called by the server
      root: true,
      // eslint-disable-next-line no-empty-pattern
      async handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.UPDATE_BULK_DELETE_ACTION_STATUS, data)
      }
    },

    getInitialResources: {
      root: true,
      // eslint-disable-next-line no-empty-pattern
      handler({ commit, dispatch }) {
        return DataService.getOrganizationResources().then(
          ({ data: resources }) => {
            commit("setOrganization", resources.organization, { root: true })
            commit("setPortfolio", resources.portfolio, { root: true })
            commit("setUIOptions", resources.portfolio.ui_options, { root: true })
            commit("aichat/setUiState", resources.portfolio.ui_options?.timeline_chat, { root: true })
            commit("setObjectTypes", resources.portfolio.object_types, { root: true })
            commit("setMetrics", resources.metrics, { root: true })
            commit("setUsers", resources.users)
            commit("integration/setIntegrations", resources.integrations, { root: true })
            commit("integration/setMetricsMappings", resources.mappings, { root: true })
            commit("setAllBaseGraphs", resources.graphs)
            commit("setForecasts", resources.forecasts)
            commit("setFunnels", resources.funnels)
            commit("setGroups", resources.groups)
            commit("setTags", resources.tags)
            commit("setActionsTags", resources["action-tags"])
            commit("setNoteCategories", resources["notes-categories"])
            commit("setNotifications", resources.notifications)
            commit("settings/setModulesSettings", resources.modules_settings, { root: true })
            commit("auth/setIsLoggedIn", true, { root: true })
            dispatch("realtime/joinLayoutStreams", resources.portfolio, { root: true })
            commit("control/setModules", resources.modules, { root: true })

            return Promise.resolve(resources)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    },

    async savePendingPlaybook({ commit }, data) {
      commit("savePendingPlaybook", data)
    },

    refetchNotifications: {
      root: true,
      // eslint-disable-next-line no-empty-pattern
      handler({ commit }) {
        return DataService.getNotifications(store.state.auth.user.id, { page_size: 50 }).then(
          (response) => {
            commit("setNotifications", response.data)
            return response.data
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    },
    getMoreNotifications: {
      root: true,
      handler({ state, commit }) {
        return DataService.callEndpointByUrl(state.notifications.next, { page_size: 10 }).then(
          (response) => {
            let notifications = response.data
            notifications.results = state.notifications.results.concat(response.data.results)
            commit("setNotifications", notifications)
            return Promise.resolve(notifications)
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    },
    //TOBE IMPLEMENTED LATER
    // getMoreNotifications: {
    //   root: true,
    //   handler({ commit }) {
    //     return DataService.callEndpointByUrl(store.state.data.notifications.next, { page_size: 10 }).then(
    //       (response) => {
    //         commit("getMoreNotifications", response.data)
    //         return response.data
    //       },
    //       (error) => {
    //         return Promise.reject(error)
    //       }
    //     )
    //   }
    // },
    updateForecasting: {
      root: true,
      // eslint-disable-next-line no-empty-pattern
      handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.REFRESH_FORECAST, data)
        this.$emitter.emit(ALL_EMITTERS.UPDATE_FORECASTING, data)
      }
    },

    setOrganization({ commit }, org) {
      commit("setOrganization", org, { root: true })
    },

    initPlaybookTriggerOptions({ commit }, data) {
      commit("initPlaybookTriggerOptions", data)
    },
    deleteForecasting: {
      root: true,
      // eslint-disable-next-line no-empty-pattern
      handler({}, data) {
        this.$emitter.emit(ALL_EMITTERS.DELETE_FORECAST, data)
      }
    },
    "RECORD.UPDATE": {
      root: true,
      handler({ dispatch }, data) {
        dispatch("data/emitRecordUpdatedEmitters", data, { root: true })
      }
    },
    // eslint-disable-next-line no-empty-pattern
    emitRecordUpdatedEmitters({}, updated_record) {
      this.$emitter.emit(ALL_EMITTERS.RECORD_UPDATED_IN_OVERVIEW_COMPONENT, updated_record)
      // RECORD_UPDATED_IN_OWNERS_LIST_COMPONENT emit removed: it had no listener anywhere (dead).
      this.$emitter.emit(ALL_EMITTERS.RECORD_UPDATED_IN_LAYOUT_ITEM_WRAPPER, updated_record)
    },
    setPlanExpandData({ commit }, data) {
      commit("setPlanExpandData", data)
    },

    setProspectingFilterBy({ commit }, filter) {
      commit("setProspectingFilter", filter)
    },
    setPhasesObjectType({ commit }, object_type) {
      commit("setPhasesObjectType", object_type)
    },

    setSuggestedObjectType({ commit }, object_type) {
      commit("setSuggestedObjectType", object_type)
    },

    setGrowthObjectType({ commit }, object_type) {
      commit("setGrowthObjectType", object_type)
    },
    updatePhasesSolidMetrics({ commit }, { id, list }) {
      commit("updatePhasesSolidMetrics", { id, list })
    },
    updateGrowthSolidMetrics({ commit }, { id, list }) {
      commit("updateGrowthSolidMetrics", { id, list })
    },

    updateSuggestedSolidMetrics({ commit }, { id, list }) {
      commit("updateSuggestedSolidMetrics", { id, list })
    },

    updateSearchList({ commit }, list) {
      commit("updateSearchList", list)
    },
    removeGroup: {
      root: true,
      handler({ commit }, { id, group_type }) {
        if (group_type == "suggested" || group_type == "growth_matrix") {
          this.$emitter.emit(ALL_EMITTERS.RESET_NEW_LEADS_TABLE)
          if (group_type == "suggested") {
            this.$emitter.emit(ALL_EMITTERS.REMOVE_SUGGESTED_LIST_IN_SUGGESTED_LIST_COMPONENT, id)
            this.$emitter.emit(ALL_EMITTERS.REMOVE_SUGGESTED_LIST_IN_PROSPECTING_COMPONENT, id)
            this.$emitter.emit(ALL_EMITTERS.REMOVE_SUGGESTED_LIST_IN_ADMIN_SETTINGS, id)
          } else {
            this.$emitter.emit(ALL_EMITTERS.REMOVE_GROWTH_LIST_FROM_GROWTH_MATRIX_COMPONENT, id)
            this.$emitter.emit(ALL_EMITTERS.REMOVE_GROWTH_LIST_FROM_SWOT_VIEW, id)
          }
        } else {
          commit("removeGroup", id)
        }
      }
    },
    addGroup: {
      root: true,
      handler({ commit }, { id, group_type }) {
        if (group_type == "suggested" || group_type == "growth_matrix") {
          this.$emitter.emit(ALL_EMITTERS.RESET_NEW_LEADS_TABLE)
        } else {
          DataService.getGroup(id).then(
            (response) => {
              commit("addGroup", response.data)
            },
            (error) => {
              return Promise.reject(error)
            }
          )
        }
      }
    },
    fetchTeams: {
      handler({ commit }) {
        return DataService.getOrganizationTeams().then(
          (response) => {
            commit("setTeams", response.data.results)
            return response.data.results
          },
          (error) => {
            return Promise.reject(error)
          }
        )
      }
    },

    changeDefaultWorkspaceOrganization({ commit }, data) {
      commit("changeDefaultWorkspaceOrganization", data)
    },

    async markNotificationAsSeen({ dispatch }, { user_id, notification_id }) {
      return await DataService.markNotificationAsSeen(user_id, notification_id).then(
        () => {
          dispatch("refetchNotifications", {}, { root: true })
          return Promise.resolve()
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async markAllNotificationAsSeen({ dispatch }, { user_id }) {
      return await DataService.markAllNotificationAsSeen(user_id).then(
        () => {
          dispatch("refetchNotifications", {}, { root: true })
          return Promise.resolve()
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getUsers({ commit }) {
      return await DataService.getOrganizationUsers({ page_size: 500 }).then(
        (response) => {
          commit("setOrganizationUsers", response.data.results)
          return response.data.results
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async createWorkspace({ commit }, data) {
      return await DataService.createWorkspace(data).then(
        (res) => {
          commit("addWorkspace", res.data)
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async deleteWorkspace({ commit }, id) {
      return await DataService.deleteWorkspace(id).then(
        (res) => {
          commit("deleteWorkspace", id)
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getMyWorkspaceOrganizations({ commit }) {
      return await DataService.getMyWorkspaceOrganizations().then(
        (res) => {
          commit("setWorkspaceOrganizations", res.data)
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async updateWorkspace({ commit, dispatch }, data) {
      return await DataService.updateWorkspace(data).then(
        (res) => {
          commit("updateWorkspace", res.data)
          if (store.state.ui.currentWorkspace?.short_id == res.data.short_id) {
            dispatch("ui/setCurrentWorkspace", res.data, { root: true })
          }
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async addWorkspaceTeamMember({ commit, dispatch }, data) {
      return await DataService.addWorkspaceTeamMember(data).then(
        (res) => {
          commit("updateWorkspace", res.data)
          if (store.state.ui.currentWorkspace?.short_id == res.data.short_id) {
            dispatch("ui/setCurrentWorkspace", res.data, { root: true })
          }
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async updateWorkspaceTeamMemberAccessScope({ commit, dispatch }, data) {
      return await DataService.updateWorkspaceTeamMemberAccessScope(data).then(
        (res) => {
          commit("updateWorkspace", res.data)
          if (store.state.ui.currentWorkspace?.short_id == res.data.short_id) {
            dispatch("ui/setCurrentWorkspace", res.data, { root: true })
          }
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getWorkspaces({ commit }, params) {
      return await DataService.getWorkspaces(params).then(
        (res) => {
          commit("setWorkspaces", res.data)
          // dispatch("realtime/joinStreams", res.data.id, { root: true })
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getMoreWorkspaces({ commit, dispatch, state }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.getRecordsByUrl(state.workspaces.next).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })
          commit("setMoreWorkspaces", response.data)
          return response.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async updateWorkspaceContactAccessScope({ commit, dispatch }, data) {
      return await DataService.updateWorkspaceContactAccessScope(data).then(
        (res) => {
          commit("updateWorkspace", res.data)
          if (store.state.ui.currentWorkspace?.short_id == res.data.short_id) {
            dispatch("ui/setCurrentWorkspace", res.data, { root: true })
          }
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async removeWorkspaceTeamMember({ commit, dispatch }, data) {
      return await DataService.removeWorkspaceTeamMember(data).then(
        (res) => {
          commit("updateWorkspace", res.data)
          if (store.state.ui.currentWorkspace?.short_id == res.data.short_id) {
            dispatch("ui/setCurrentWorkspace", res.data, { root: true })
          }
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async addWorkspaceCollaborator({ commit, dispatch }, data) {
      return await DataService.addWorkspaceCollaborator(data).then(
        (res) => {
          commit("updateWorkspace", res.data)
          if (store.state.ui.currentWorkspace?.short_id == res.data.short_id) {
            dispatch("ui/setCurrentWorkspace", res.data, { root: true })
          }
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async removeWorkspaceCollaborator({ commit, dispatch }, data) {
      return await DataService.removeWorkspaceCollaborator(data).then(
        (res) => {
          commit("updateWorkspace", res.data)
          if (store.state.ui.currentWorkspace?.short_id == res.data.short_id) {
            dispatch("ui/setCurrentWorkspace", res.data, { root: true })
          }
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getMetrics({ commit, dispatch }) {
      return DataService.getOrganizationMetrics({ page_size: 1000 }).then(
        (response) => {
          dispatch("integration/getMetricsMapping", null, { root: true })
          commit("setMetrics", response.data.results, { root: true })
          return response.data.results
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    async addMetric({ commit }, data) {
      return await DataService.addOrganizationMetric(data).then(
        (response) => {
          commit("addMetric", response.data, { root: true })
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getGraphs({ commit }, { page_reference = "", page_size = 5, ...params }) {
      return await DataService.getGraphs({ page_size, page_reference, ...params }).then(
        (response) => {
          commit("setGraphs", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    decreaseUnreadCountByOne({ commit }) {
      commit("decreaseUnreadCountByOne")
    },

    async getEmailsSummary({ commit }) {
      return await DataService.getEmailsSummary().then(
        (response) => {
          commit("setEmailsSummary", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getAllGraphsFlat({ commit }) {
      return await DataService.getAllGraphsFlat().then(
        (response) => {
          commit("setAllBaseGraphs", response.data)
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getGraph({ commit }, { graph_id, params = {} }) {
      if (
        store.state.data.graphs_fetched[graph_id] &&
        params?.record &&
        store.state.data.graphs_fetched[graph_id].record == params.record
      ) {
        return new Promise((resolve) => {
          resolve({ data: store.state.data.graphs_fetched[graph_id] })
        })
      } else {
        if (
          !store.state.data.graphs_currently_fetching?.includes(graph_id) ||
          (store.state.data.graphs_currently_fetching?.includes(graph_id) &&
            params?.record &&
            store.state.data.graphs_fetched[graph_id].record != params.record)
        ) {
          commit("setGraphsCurrentlyFetching", store.state.data.graphs_currently_fetching.concat(graph_id))
          return await DataService.getGraph(graph_id, params).then(
            (res) => {
              if (params.record) {
                res.data["record"] = params.record
              }
              commit("setGraph", res.data)
              return res
            },
            (error) => {
              commit("setGraphsCurrentlyFetching", null)
              return Promise.reject(error)
            }
          )
        } else {
          let promise_calc = null
          const full_promise = new Promise((resolve) => {
            const promiseObj = { resolve }
            promise_calc = promiseObj
          })
          const promise_obj = { graph_id, id: uuidv4(), promise: promise_calc }
          commit("addToGetGraphQueue", promise_obj)
          return full_promise
        }
      }
    },

    async createGraph({ commit }, data) {
      return await DataService.createGraph(data).then(
        (response) => {
          commit(ALL_EMITTERS.CREATE_GRAPH, response.data)
          return response.data
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async updateGraph({ commit }, { id, data }) {
      return await DataService.updateGraph(id, data).then(
        (response) => {
          commit("updateGraph", response.data)
          return response.data
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async removeGraph({ commit }, id) {
      return await DataService.removeGraph(id).then(
        (response) => {
          commit("removeGraph", id)
          return response.data
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    async getGroups({ commit }) {
      return await DataService.getGroups({ page_size: 100 }).then(
        (response) => {
          commit("setGroups", response.data.results)
          return response.data.results
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getTags({ commit }) {
      return await DataService.getTags({ page_size: 100 }).then(
        (response) => {
          commit("setTags", response.data.results)
          return response.data.results
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getActionsTags({ commit }) {
      return await DataService.getActionsTags({ page_size: 100 }).then(
        (response) => {
          commit("setActionsTags", response.data.results)
          return response.data.results
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getNoteCategories({ commit }) {
      return await DataService.getNoteCategories({ page_size: 100 }).then(
        (response) => {
          commit("setNoteCategories", response.data.results)
          return response.data.results
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async bulkRecordsDelete(_, records) {
      //should be replaced with bulkInteractionsCreate request
      return await DataService.bulkRecordsDelete(records).then(
        (response) => {
          // TODO : remove records from store
          return response.data
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    bulkRecordsMetricUpdate(_, data) {
      //should be replaced with bulkInteractionsCreate request
      return DataService.bulkRecordsMetricUpdate(data).then(
        (response) => {
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    mergeMetricsValues(_, data) {
      //should be replaced with bulkInteractionsCreate request
      return DataService.mergeMetricsValues(data).then(
        (response) => {
          return Promise.resolve(response.data)
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async bulkInteractionCreate({ dispatch }, { interaction }) {
      //should be replaced with bulkInteractionsCreate request

      dispatch("ui/showLoading", null, { root: true })
      return await DataService.bulkInteractionCreate(interaction).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })

          response.data.forEach((interaction) => {
            this.$emitter.emit(ALL_EMITTERS.NEW_INTERACTION_ADDED, interaction)
          })

          return response.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async bulkTaskCreate({ dispatch }, { task }) {
      //should be replaced with bulkInteractionsCreate request
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.bulkTaskCreate(task).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })
          response.data.forEach((task) => {
            this.$emitter.emit(ALL_EMITTERS.NEW_TASK_ADDED, task)
          })

          return response.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async bulkGoalCreate({ dispatch }, { goal, params }) {
      //should be replaced with bulkInteractionsCreate request
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.bulkGoalCreate(goal, params).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })

          response.data.forEach((goal) => {
            this.$emitter.emit(ALL_EMITTERS.NEW_GOAL_ADDED, goal)
          })

          return response.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async updateOrganizationMetric({ commit }, metric) {
      return await DataService.updateOrganizationMetric(metric).then((response) => {
        commit("updateMetric", response.data)
      })
    },
    async updateMetric({ commit }, metric) {
      return await DataService.updateOrganizationMetric(metric)
        .then((response) => {
          commit("updateMetric", response.data)
          return Promise.resolve(response.data)
        })
        .catch((error) => {
          return Promise.reject(error)
        })
    },

    async deleteOrganizationMetric({ commit }, metric) {
      return await DataService.deleteOrganizationMetric(metric.id).then(() => {
        commit("deleteMetric", metric, { root: true })
      })
    },

    async addAttachmentsToInteraction({ dispatch }, { id, attachments, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.addAttachmentsToInteraction(id, attachments, params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },
    async deleteAttachmentsFromInteraction({ dispatch }, { id, attachments_ids, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.deleteAttachmentsFromInteraction(id, { attachments_ids: attachments_ids }, params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async addAttachmentsToTask({ dispatch }, { id, attachments, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.addAttachmentsToTask(id, attachments, params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },
    async deleteAttachmentsFromTask({ dispatch }, { id, attachments_ids, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.deleteAttachmentsFromTask(id, { attachments_ids: attachments_ids }, params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async addAttachmentsToGoal({ dispatch }, { id, attachments, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.addAttachmentsToGoal(id, attachments, params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async deleteAttachmentsFromGoal({ dispatch }, { id, attachments_ids, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.deleteAttachmentsFromGoal(id, { attachments_ids: attachments_ids }, params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async createPlan({ dispatch }, { plan }) {
      dispatch("ui/showLoading", null, { root: true })

      return await DataService.createPlan(plan).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.NEW_PLAN_ADDED, res.data)

          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },
    async addAttachmentsToPlan({ dispatch }, { id, attachments, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.addAttachmentsToPlan(id, attachments, params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },
    async deleteAttachmentsFromPlan({ dispatch }, { id, attachments_ids, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.deleteAttachmentsFromPlan(id, { attachments_ids: attachments_ids }, params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async updateInteraction({ dispatch }, { interaction }) {
      //should be replaced with interactionUpdate request

      dispatch("ui/showLoading", null, { root: true })
      return await DataService.updateInteraction(interaction.id, interaction).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })
          return response.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async updateTask({ dispatch }, { task, params }) {
      //should be replaced with interactionUpdate request

      if (!task.dont_load) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.updateTask(task.id, task, params).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.TASK_UPDATED, response.data)
          return response.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async updateGoal({ dispatch }, { goal }) {
      //should be replaced with interactionUpdate request
      if (!goal.dont_load) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.updateGoal(goal.id, goal).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.GOAL_UPDATED, response.data)

          return response.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async updatePlan({ dispatch }, { plan, params }) {
      //should be replaced with interactionUpdate request

      if (!plan.dont_load) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.updatePlan(plan.id, plan, params).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.PLAN_UPDATED, response.data)
          return response.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async removeInteraction({ dispatch }, { interaction }) {
      //should be replaced with interactionDelete request

      dispatch("ui/showLoading", null, { root: true })

      return await DataService.removeInteraction(interaction.id).then(
        () => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.INTERACTION_REMOVED, interaction)

          return interaction
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async removeTask({ dispatch }, { task }) {
      //should be replaced with interactionDelete request

      dispatch("ui/showLoading", null, { root: true })

      return await DataService.removeTask(task.id).then(
        () => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.TASK_REMOVED, task)

          return task
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async removeGoal({ dispatch }, { goal }) {
      //should be replaced with interactionDelete request

      dispatch("ui/showLoading", null, { root: true })

      return await DataService.removeGoal(goal.id).then(
        () => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.GOAL_REMOVED, goal)

          return goal
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async removePlan({ dispatch }, { plan }) {
      //should be replaced with interactionDelete request

      dispatch("ui/showLoading", null, { root: true })

      return await DataService.removePlan(plan.id).then(
        () => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.PLAN_REMOVED, plan)
          return plan
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getRecordNotes({ commit }, record_id) {
      if (store.state.data.records_notes_fetched[record_id]) {
        return new Promise((resolve) => {
          resolve(store.state.data.records_notes_fetched[record_id])
        })
      } else {
        if (record_id !== store.state.data.record_notes_currently_fetching) {
          commit("setRecordNotesCurrentlyFetching", record_id)
          return await DataService.getRecordNotes(record_id).then(
            (res) => {
              let d = {
                id: record_id,
                data: res.data
              }
              commit("setRecordNotes", d)
              commit("setRecordNotesEmpty", {})
              return res
            },
            (error) => {
              commit("setRecordNotesCurrentlyFetching", null)
              return Promise.reject(error)
            }
          )
        } else {
          let promise_calc = null
          const full_promise = new Promise((resolve) => {
            const promiseObj = { resolve }
            promise_calc = promiseObj
          })
          const promise_obj = { record_id, id: uuidv4(), promise: promise_calc }
          commit("addToGetRecordNotesQueue", promise_obj)
          return full_promise
        }
      }
    },

    async getRecord({ commit }, record_id) {
      if (store.state.data.records_fetched[record_id]) {
        return new Promise((resolve) => {
          resolve({ data: store.state.data.records_fetched[record_id] })
        })
      } else {
        if (!store.state.data.records_currently_fetching.includes(record_id)) {
          commit("setRecordsCurrentlyFetching", store.state.data.records_currently_fetching.concat(record_id))
          return await DataService.getRecord(record_id).then(
            (res) => {
              commit("setRecord", res.data)
              return res
            },
            (error) => {
              commit(
                "setRecordsCurrentlyFetching",
                store.state.data.records_currently_fetching.filter((id) => id !== record_id)
              )
              return Promise.reject(error)
            }
          )
        } else {
          let promise_calc = null
          const full_promise = new Promise((resolve) => {
            const promiseObj = { resolve }
            promise_calc = promiseObj
          })
          const promise_obj = { record_id, id: uuidv4(), promise: promise_calc }
          commit("addToGetRecordQueue", promise_obj)
          return full_promise
        }
      }
    },

    async updateRecord({ commit }, { record_id, data }) {
      return await DataService.updateRecord(record_id, data).then(
        (res) => {
          commit("setRecord", res.data)
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },
    async updateRecordMetric({ commit }, { record_id, data }) {
      return await DataService.updateRecordMetric(record_id, data).then(
        (res) => {
          commit("setRecord", res.data)
          return res
        },
        (error) => {
          return Promise.reject(error)
        }
      )
    },

    async getInteractions({ dispatch }, params) {
      if (!params.prevent_loading) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.getAllInteractions(params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          //Uncomment when BE is linked to send list from response instead
          //return response.data
          //commit("setRecordInteractions", response.data)

          return { data: res.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async createInteraction({ dispatch }, { interaction }) {
      //should be replaced with interactionCreate request
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.createInteraction(interaction).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          this.$emitter.emit(ALL_EMITTERS.NEW_INTERACTION_ADDED, res.data)

          return res.data
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getCalendarInteractions({ commit, dispatch }, params) {
      if (!params.prevent_loading) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.getAllInteractions(params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          //Uncomment when BE is linked to send list from response instead
          //return response.data
          //commit("setRecordInteractions", response.data)

          commit("setCalendarInteractions", { ...res.data, results: res.data.results })
          return { data: res.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getTasks({ dispatch }, params) {
      if (!params.prevent_loading) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.getTasks(params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          //Uncomment when BE is linked to send list from response instead
          //return response.data
          //commit("setRecordInteractions", response.data)

          return { data: res.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getCalendarTasks({ commit, dispatch }, params) {
      if (!params.prevent_loading) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.getTasks(params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          //Uncomment when BE is linked to send list from response instead
          //return response.data
          //commit("setRecordInteractions", response.data)

          commit("setCalendarTasks", res.data)
          return { data: res.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getGoals({ dispatch }, params) {
      if (!params.prevent_loading) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.getGoals(params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          //Uncomment when BE is linked to send list from response instead
          //return response.data
          //commit("setRecordInteractions", response.data)

          return { data: res.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getCalendarGoals({ commit, dispatch }, params) {
      if (!params.prevent_loading) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.getGoals(params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          //Uncomment when BE is linked to send list from response instead
          //return response.data
          //commit("setRecordInteractions", response.data)

          commit("setCalendarGoals", res.data)
          return { data: res.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getPlans({ dispatch }, params) {
      if (!params.prevent_loading) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.getPlans(params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })
          return { data: res.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getCalendarPlans({ commit, dispatch }, params) {
      if (!params.prevent_loading) {
        dispatch("ui/showLoading", null, { root: true })
      }
      return await DataService.getPlans(params).then(
        (res) => {
          dispatch("ui/hideLoading", null, { root: true })

          //Uncomment when BE is linked to send list from response instead
          //return response.data
          //commit("setRecordInteractions", response.data)

          commit("setCalendarPlans", res.data)
          return { data: res.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getRecordInteractions({ dispatch }, { id, params, for_contact }) {
      if (for_contact) {
        return await DataService.getAllInteractions(params).then(
          (response) => {
            dispatch("ui/hideLoading", null, { root: true })
            return { data: response.data }
          },
          (error) => {
            dispatch("ui/hideLoading", null, { root: true })
            return Promise.reject(error)
          }
        )
      } else {
        return await DataService.getInteractions(id, params).then(
          (response) => {
            dispatch("ui/hideLoading", null, { root: true })
            return { data: response.data }
          },
          (error) => {
            dispatch("ui/hideLoading", null, { root: true })
            return Promise.reject(error)
          }
        )
      }
    },

    async getRecordTasks({ dispatch }, { id, params, for_contact }) {
      dispatch("ui/showLoading", null, { root: true })

      if (for_contact) {
        return await DataService.getTasks(params).then(
          (response) => {
            dispatch("ui/hideLoading", null, { root: true })
            return { data: response.data }
          },
          (error) => {
            dispatch("ui/hideLoading", null, { root: true })
            return Promise.reject(error)
          }
        )
      } else {
        return await DataService.getRecordTasks(id, params).then(
          (response) => {
            dispatch("ui/hideLoading", null, { root: true })
            return { data: response.data }
          },
          (error) => {
            dispatch("ui/hideLoading", null, { root: true })
            return Promise.reject(error)
          }
        )
      }
    },

    async getRecordGoals({ dispatch }, { id, params, for_contact }) {
      dispatch("ui/showLoading", null, { root: true })
      if (for_contact) {
        return await DataService.getGoals(params).then(
          (response) => {
            dispatch("ui/hideLoading", null, { root: true })
            return { data: response.data }
          },
          (error) => {
            dispatch("ui/hideLoading", null, { root: true })
            return Promise.reject(error)
          }
        )
      } else {
        return await DataService.getRecordGoals(id, params).then(
          (response) => {
            dispatch("ui/hideLoading", null, { root: true })
            return { data: response.data }
          },
          (error) => {
            dispatch("ui/hideLoading", null, { root: true })
            return Promise.reject(error)
          }
        )
      }
    },

    async getRecordPlans({ dispatch }, { id, params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.getRecordPlans(id, params).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })
          return { data: response.data }
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getRecords({ dispatch }, { params }) {
      dispatch("ui/showLoading", null, { root: true })
      return await DataService.getRecords({ params }).then(
        (response) => {
          dispatch("ui/hideLoading", null, { root: true })
          return response.data.results
        },
        (error) => {
          dispatch("ui/hideLoading", null, { root: true })
          return Promise.reject(error)
        }
      )
    },

    async getForecasts({ commit }) {
      return await DataService.getForecasts().then((res) => {
        commit("setForecasts", res.data.results)
      })
    },

    selectForecast({ commit }, data) {
      commit("selectForecast", data)
    }
  },
  mutations: {
    savePendingPlaybook(state, data) {
      state.pending_playbook = data
    },
    initPlaybookTriggerOptions(state) {
      let all_objects_text = ""
      store.state.object_types.forEach((object_type, i) => {
        if (i) {
          all_objects_text += "__"
        }
        all_objects_text += object_type.type
      })
      state.playbook_triggers = [
        {
          name: "is created",
          value: "is_created",
          for: `record__goal__task__plan__interaction__customer_journey__phase__growth_matrix__suggested_list__forecast__metric__milestone__${all_objects_text}`,
          hide_async: true
        },
        {
          name: "is updated",
          value: "is_updated",
          for: `record__goal__task__plan__interaction__customer_journey__phase__growth_matrix__suggested_list__forecast__metric__milestone__${all_objects_text}`
        },
        {
          name: "is deleted",
          value: "is_deleted",
          for: `record__goal__task__plan__interaction__customer_journey__phase__growth_matrix__suggested_list__forecast__metric__milestone__${all_objects_text}`
        },
        {
          name: "webhook received",
          value: "webhook_received",
          for: "webhook",
          description: "Triggered when a webhook request is received from external systems"
        }
      ]
    },
    stateReset(state) {
      Object.assign(state, initialState)
    },
    addWorkspace(state, data) {
      state.workspaces.results.push(data)
    },

    deleteWorkspace(state, id) {
      let workspace_resutlts = [...state.workspaces.results]
      if (workspace_resutlts.find((w) => w.short_id == id)) {
        workspace_resutlts = workspace_resutlts.filter((workspace) => workspace.short_id !== id)
        state.workspaces = { ...state.workspaces, results: workspace_resutlts, count: state.workspaces.count - 1 }
      }
    },

    setWorkspaces(state, data) {
      state.workspaces = data
    },

    setMoreWorkspaces(state, data) {
      let workspace_results = [...state.workspaces.results]
      workspace_results = workspace_results.concat(data.results)
      state.workspaces = { ...state.workspaces, results: workspace_results, next: data.next, count: data.count, previous: data.previous }
    },

    updateWorkspace(state, data) {
      const index = state.workspaces.results?.findIndex((w) => w.short_id == data.short_id)
      if (state.workspaces.results && index !== -1) {
        state.workspaces.results.splice(index, 1, { ...state.workspaces.results[index], ...data })
      }
    },
    setRecord(state, data) {
      if (data?.id) {
        state.records_fetched[data.id] = data
        state.get_record_promises_queue.forEach((promise_obj) => {
          if (promise_obj.record_id == data.id) {
            try {
              promise_obj.promise?.resolve({ data: data })
            } catch (error) {
              console.debug("NOT A PROMISEEEE", error)
            }
          }
        })
        state.get_record_promises_queue = state.get_record_promises_queue.filter((p) => p.record_id !== data.id)
      }
    },

    setRecordNotes(state, data) {
      state.records_notes_fetched[data.id] = utils.clone(data)
      state.record_notes_currently_fetching = null
      state.get_record_notes_promises_queue.forEach((promise_obj) => {
        if (promise_obj.record_id == data.id) {
          try {
            promise_obj.promise?.resolve(data)
          } catch (error) {
            console.debug("NOT A PROMISEEEE", error)
          }
        }
      })
      state.get_record_notes_promises_queue = state.get_record_notes_promises_queue.filter((p) => p.record_id !== data.id)
    },

    addToGetRecordQueue(state, data) {
      state.get_record_promises_queue.push(data)
    },
    addToGetGraphQueue(state, data) {
      state.get_graphs_promises_queue.push(data)
    },
    setRecordNotesEmpty(state, data) {
      state.records_notes_fetched = data
    },
    addToGetRecordNotesQueue(state, data) {
      state.get_record_notes_promises_queue.push(data)
    },
    setRecordsCurrentlyFetching(state, data) {
      state.records_currently_fetching = data
    },
    setGraphsCurrentlyFetching(state, data) {
      state.graphs_currently_fetching = data
    },
    setRecordNotesCurrentlyFetching(state, data) {
      state.record_notes_currently_fetching = utils.clone(data)
    },

    setEmailsSummary(state, data) {
      state.emails_summary = data
    },

    decreaseUnreadCountByOne(state) {
      state.emails_summary = { ...state.emails_summary, inbox_unread_count: state.emails_summary.inbox_unread_count - 1 }
    },
    setPlanExpandData(state, data) {
      state.plan_data = data
    },
    setProspectingFilter(state, filter) {
      state.prospecting_filter = filter
    },

    setSuggestedObjectType(state, object_type) {
      state.suggested_object_type = object_type
    },

    setGrowthObjectType(state, object_type) {
      state.growth_object_type = object_type
    },

    updateMetric(state, metric) {
      const index = state.metrics.findIndex((m) => m.id == metric.id)
      state.metrics.splice(index, 1, metric)
    },
    deleteMetric(state, metric) {
      const index = state.metrics.findIndex((m) => m.id == metric.id)
      state.metrics.splice(index, 1)
    },
    updatePhasesSolidMetrics(state, { id, list }) {
      state.solid_metrics_phases[id] = list
    },
    updateGrowthSolidMetrics(state, { id, list }) {
      state.solid_metrics_growth[id] = list
    },
    updateSuggestedSolidMetrics(state, { id, list }) {
      state.solid_metrics_suggested[id] = list
    },

    updateSearchList(state, data) {
      state.recent_searches = data
    },

    setOrganizationUsers(state, users) {
      state.organization_users = users
    },
    setUsers(state, users) {
      state.users = users
    },
    setGroups(state, groups) {
      state.groups = groups
    },
    setGraph(state, data) {
      if (data?.id) {
        let g = state.all_graphs.find((g) => g.id == data.id)
        g["datasets"] = data.datasets
        state.graphs_fetched[data.id] = g
        utils.removeItem(state.graphs_currently_fetching, g)
        state.get_graphs_promises_queue.forEach((promise_obj) => {
          if (promise_obj.id == g.id) {
            try {
              promise_obj.promise?.resolve(g)
            } catch (error) {
              console.error(error)
            }
          }
        })
        state.get_graphs_promises_queue = state.get_graphs_promises_queue.filter((p) => p.id !== data.id)
      }
    },
    setTags(state, tags) {
      state.tags = tags
    },
    setActionsTags(state, tags) {
      state.actions_tags = tags
    },
    setNoteCategories(state, categories) {
      state.note_categories = categories
    },
    setNotifications(state, notifications) {
      state.notifications = notifications
    },
    //TOBE IMPLEMENTED LATER
    // getMoreNotifications(state, data) {
    //   state.notifications = { ...state.notifications, next: data.next, previous: data.previous, results: data.results.concat(state.notifications.results) }
    // },
    removeGroup(state, id) {
      let index = state.groups.findIndex((x) => x.id == id)
      state.groups.splice(index, 1)
    },
    addGroup(state, data) {
      state.groups.unshift(data)
    },
    setMetrics(state, metrics) {
      state.metrics = metrics
    },

    setGraphs(state, graphs) {
      state.graphs = utils.clone(graphs)
      state.all_graphs = utils.clone(graphs)
    },

    setAllBaseGraphs(state, graphs) {
      state.all_graphs = utils.clone(graphs)
      state.graphs = utils.clone(graphs)
    },
    addGraph(state, graph) {
      state.graphs.push(graph)
    },
    updateGraph(state, data) {
      state.graphs = utils.replaceItem(state.graphs, data)
      state.graphs_fetched[data.id] = data
    },
    createGraph(state, data) {
      state.graphs = [data].concat(state.graphs)
      state.all_graphs.push(data)
    },
    removeGraph(state, id) {
      state.graphs = state.graphs.filter((g) => g.id !== id)
    },

    setCalendarInteractions(state, { data, record_id }) {
      state.calendar_interactions[record_id] = data
    },

    setCalendarTasks(state, data) {
      state.calendar_tasks = data
    },

    setCalendarGoals(state, data) {
      state.calendar_goals = data
    },
    setTeams(state, teams) {
      state.teams = teams
    },

    changeDefaultWorkspaceOrganization(state, data) {
      state.selected_organization = data
    },
    changeOrganization(state, data) {
      state.selected_organization = data
    },
    setWorkspaceOrganizations(state, data) {
      state.workspace_organizations = data
      state.selected_organization = data[0]
    },
    setCalendarPlans(state, data) {
      state.calendar_plans = data
    },

    setCurrentObjectType(state, object_type) {
      state.current_object_type = object_type
    },
    addMetric(state, metric) {
      state.metrics.unshift(metric)
    },

    selectForecast(state, data) {
      state.current_forecast = data
      state.forecast_current_object = state.forecasted_objects.find((f) => f.type == data.type)
    },
    setFunnels(state, data) {
      state.funnels = data
    },
    setForecasts(state, data) {
      if (data.length) {
        state.user_forecasts = data

        state.forecasted_objects = utils.uniqBy(state.user_forecasts, "type").map((x) => {
          return { ...utils.getObjectTypeById(x.object_type) }
        })
        if (state.user_forecasts.length > 0) {
          state.forecast_current_object = state.forecasted_objects[0]
          state.current_forecast = state.user_forecasts.filter((f) => f.type == state.forecast_current_object.type)[0]
        } else {
          state.forecast_current_object = null
        }
      } else {
        state.forecast_current_object = null
        state.current_forecast = null
        state.user_forecasts = []
        state.forecasted_objects = []
      }
    },
    deleteUserForecast(state, forecasting_settings_id) {
      state.user_forecasts = state.user_forecasts.filter((f) => f.forecast_settings !== forecasting_settings_id)
    }
  }
}
